import { render, staticRenderFns } from "./infoHeader.vue?vue&type=template&id=c56bceaa&"
import script from "./infoHeader.vue?vue&type=script&lang=ts&"
export * from "./infoHeader.vue?vue&type=script&lang=ts&"
import style0 from "./infoHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports